<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 09:38:26
 * @LastEditTime: 2020-06-20 13:47:10
 * @Description: 题目详情页面
 -->
<template>
  <div v-if="loaded" class="content">
    <!-- <question-info
      :library-id="libraryId"
      :need-media="needMedia"
      :question-type="questionType"
      :info="info" @repull-question-info="repullQuestionInfoHandler" /> -->
    <question-stem
      :stem="stem"
      :menu="menu"
      :library-id="libraryId"
      :media-type="mediaType"
      @set-stem="setStemHandler"
      @set-stem-edit-flag="setStemEditFlagHandler"
      @repull-question-info="repullQuestionInfoHandler"
      @preview-media="previewMediaFileHandler"
    />
    <question-option
      :question-type="questionType"
      :options="options"
      :library-id="libraryId"
      :media-type="mediaType"
      @set-options="setOptionsHandler"
      @set-options-edit-flag="setOptionsEditFlagHandler"
      @repull-question-info="repullQuestionInfoHandler"
      @preview-media="previewMediaFileHandler"
    />
    <question-resolve
      :library-id="libraryId"
      :resolve="resolve"
      @set-resolve="setResolveHandler"
      @set-resolve-edit-flag="setResolveEditFlagHandler"
      @repull-question-info="repullQuestionInfoHandler"
    />
    <preview-media-modal
      :show="previewMediaModalShow"
      :media-path="previewMediaPath"
      :media-type="previewMediaType"
      :video-cover="previewVideoCover"
      @close-modal="closeModalHandler"
    />

    <pdf-player-modal
      :show="previewPdfMediaModalShow"
      :media-type="previewMediaType"
      :url="previewMediaPath"
      @close-modal="previewPdfMediaModalShow = false"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from 'axios';
import QuestionInfo from "./components/QuestionInfo.vue";
import QuestionStem from "./components/QuestionStem.vue";
import QuestionOption from "./components/QuestionOption.vue";
import QuestionResolve from "./components/QuestionResolve.vue";
import PreviewMediaModal from "../../answer/online/components/PreviewMediaModal.vue";
import PdfPlayerModal from "../../answer/online/components/PdfPlayerModal.vue";

const breadcrumb = [
  { text: "统考中心", href: "/tr/portal/index.jsp" },
  { text: "试题库" },
  { text: "题目详情" },
];

export default {
  name: "QuestionDetail",
  components: {
    QuestionInfo,
    QuestionStem,
    QuestionOption,
    QuestionResolve,
    PreviewMediaModal,
    PdfPlayerModal,
  },
  props: {
    libraryId: { type: String, required: true },
  },
  data() {
    return {
      loaded: false,
      info: {
        libraryType: "",
        level: "",
      },
      questionType: "",
      stem: {
        libraryType: "",
        groupCode: "",
        level: "",
        shortName: "",
        year: "",
        content: "",
        mediaPath: "",
      },
      menu: {},
      options: [],
      mediaType: false,
      needMedia: false,
      resolve: "",
      previewMediaModalShow: false,
      previewMediaPath: "",
      previewMediaType: "",
      previewVideoCover: "",
      previewPdfMediaModalShow: false,
      editFlag: {
        stem: false,
        options: [],
        resolve: false,
      },
    };
  },
  watch: {
    libraryId: {
      immediate: true,
      handler() {
        this.requestQuestionDetailAndSetting();
      },
    },
    options(options) {
      this.stem.options = new Array(options.length).fill(false);
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: "pageStore/invokeSetBreadcrumb",
      setProcessingShowState: "pageStore/invokeSetProcessingShowState",
      setProcessingShowText: "pageStore/invokeSetProcessingShowText",
    }),
    /**
     * 预览媒体文件处理函数
     */
    previewMediaFileHandler({ mediaPath, realMediaPath, videoCover }) {
      const jpgReg = /jpg/;
      const pdfReg = /pdf/;
      const mp4Reg = /mp4/;
      const mp3Reg = /mp3/;

      if (jpgReg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = "jpg";
        this.previewMediaModalShow = true;
        return;
      }

      if (mp4Reg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewVideoCover = videoCover;
        this.previewMediaType = "mp4";
        this.previewMediaModalShow = true;
        return;
      }

      if (mp3Reg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = "mp3";
        this.previewMediaModalShow = true;
        return;
      }

      if (pdfReg.test(mediaPath)) {
        this.previewMediaPath = realMediaPath;
        this.previewMediaType = "pdf";
        this.previewPdfMediaModalShow = true;
        // window.open(realMediaPath, '_blank');
        // if (process.env.NODE_ENV === 'development') {
        //   window.open(`/#/tools/preview/pdf/${this.$base64.encode(realMediaPath)}`, '_blank');
        // } else {
        //   window.open(`/examcentersite/#/tools/preview/pdf/${this.$base64.encode(realMediaPath)}`, '_blank');
        // }
        return;
      }

      alert("未知类型媒体文件！");
    },
    /**
     * 关闭预览媒体模态框
     */
    closeModalHandler() {
      this.previewMediaModalShow = false;
    },
    /**
     * 设置题目题干处理函数
     */
    setStemHandler(stem) {
      this.stem = stem;
    },
    /**
     * 设置题目题干内容是否被修改flag
     */
    setStemEditFlagHandler(flag) {
      this.editFlag.stem = flag;
    },
    /**
     * 设置题目解析内容处理函数
     */
    setResolveHandler(resolve) {
      this.resolve = resolve;
    },
    /**
     * 设置题干解析内容是否被修改flag
     */
    setResolveEditFlagHandler(flag) {
      this.editFlag.resolve = flag;
    },
    /**
     * 设置题目选项内容处理函数
     */
    setOptionsHandler(options) {
      this.options = options;
    },
    /**
     * 设置题目选项内容是否被修改flag
     */
    setOptionsEditFlagHandler({ index, flag }) {
      // this.$set(this.stem.options, index, flag);
      this.editFlag.options[index] = flag;
    },
    /**
     * 重新获取题目详情处理函数
     */
    repullQuestionInfoHandler() {
      this.requestQuestionDetailAndSetting();
    },

    /**
     * 请求题目详情并设置
     */
    requestQuestionDetailAndSetting() {
      this.requestQuestionDetail();
      // this.requestQuestionDetail()
      //   .then((result) => {
      //     this.info.libraryType = result.libraryType;
      //     this.info.level = result.level;

      //     return result;
      //   })
      //   .then((result) => {
      //     this.questionType = result.questionType;

      //     return result;
      //   })
      //   .then((result) => {
      //     this.stem.libraryType = result.libraryType;
      //     this.stem.groupCode = result.groupCode;
      //     this.stem.level = result.level;
      //     this.stem.year = result.year;
      //     this.stem.shortName = result.shortName;
      //     this.stem.content = result.content;

      //     this.stem.mediaPath = result.mediaPath ? result.mediaPath : "";

      //     if (result.mediaInfoVO) {
      //       this.stem.mediaContentType = result.mediaInfoVO.mediaContentType;
      //       this.stem.realMediaPath = result.mediaInfoVO.mediaPath;
      //       this.stem.videoCover = result.mediaInfoVO.videoCover;
      //     }

      //     return result;
      //   })
      //   .then((result) => {
      //     this.options = result.options;

      //     return result;
      //   })
      //   .then((result) => {
      //     this.mediaType = result.mediaType;

      //     return result;
      //   })
      //   .then((result) => {
      //     this.needMedia = result.needMedia;

      //     return result;
      //   })
      //   .then((result) => {
      //     if (result.tip) {
      //       this.resolve = result.tip;
      //     } else {
      //       this.resolve = "";
      //     }

      //     this.loaded = true;
      //     this.setProcessingShowState({ show: false });
        // })
        // .catch(() => {
        //   alert("数据获取失败");

        //   this.loaded = true;
        //   this.setProcessingShowState({ show: false });
        // });
    },
    /**
     * 请求题目详情
     */
    requestQuestionDetail() {
      const params = {
        libraryId: this.libraryId,
      };
      axios
        .all([
          this.$http.examcenter.libraryQuestionDetail(params),
          this.$http.examcenter.libraryFilterMenu(),
        ])
        .then(
          axios.spread((questionDetail, filterMenu) => {
            if (filterMenu.code === "200") {
              this.menu = filterMenu.data;
            }

            if (questionDetail.code === "200") {
              const { data } = questionDetail;
              this.info.libraryType = data.libraryType;
              this.info.level = data.level;
              this.questionType = data.questionType;
              this.stem.libraryType = data.libraryType;
              this.stem.groupCode = data.groupCode;
              this.stem.level = data.level;
              this.stem.year = data.year;
              this.stem.shortName = data.shortName;
              this.stem.content = data.content;

              this.stem.mediaPath = data.mediaPath ? data.mediaPath : "";
              this.stem.mediaContentType = data.mediaInfoVO != null ? data.mediaInfoVO.mediaContentType : "";
              this.stem.realMediaPath =  data.mediaInfoVO != null ? data.mediaInfoVO.mediaPath : "";
              this.stem.videoCover =  data.mediaInfoVO != null ? data.mediaInfoVO.videoCover : "";
              this.options = data.options;
              this.mediaType = data.mediaType;
              this.needMedia = data.needMedia;
              if (data.tip) {
                this.resolve = data.tip;
              } else {
                this.resolve = "";
              }
              this.loaded = true;
              this.setProcessingShowState({ show: false });
            }

            if (filterMenu.code !== "200" || questionDetail.code !== "200") {
              alert("数据请求失败");
            }

            this.loaded = true;
            this.setProcessingShowState({ show: false });
          })
        );
    },
  },
  created() {
    this.setBreadcrumb({
      breadcrumb,
    });

    this.setProcessingShowState({ show: true });
  },
  beforeRouteLeave(to, from, next) {
    let optionFlag = false;

    this.editFlag.options.forEach((item) => {
      if (item) {
        optionFlag = true;
        // eslint-disable-next-line no-useless-return
        return;
      }
    });

    if (this.editFlag.stem || this.editFlag.resolve || optionFlag) {
      if (window.confirm("有修改未保存，退出将不保存任何操作！")) {
        next();
      }
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 32px;
  margin-bottom: 0;

  /deep/ .ivu-input {
    &:hover {
      border-color: #dcdee2;
    }

    &:focus {
      border-color: #dcdee2;
      box-shadow: none;
    }
  }
}
</style>
